import * as r from 'ramda';

export const proportion = r.curry((a, b, c, d, n) => {
  const deltaBA = b - a;
  const p = deltaBA / (d - c);
  return p * (n - c) + a;
});
